import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLang } from '../i18n';

export function Header() {
  const { count, setOpen } = useCart();
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-12 z-40 transition-colors duration-500 sm:top-10 ${
        scrolled
          ? 'bg-white/80 backdrop-blur-md'
          : 'bg-gradient-to-b from-white/85 via-white/50 to-transparent'
      }`}
    >
      <div className="flex h-14 items-center justify-between px-4 sm:px-10">
        <Link
          to="/"
          data-testid="header-logo"
          className="font-mono text-[11px] font-medium uppercase tracking-[0.3em]"
        >
          Vizio<sup className="text-[8px] align-super">®</sup>
        </Link>
        <div className="flex items-center gap-5 font-mono text-[10px] uppercase tracking-[0.25em]">
          <div className="flex items-center gap-2" data-testid="language-selector">
            <button
              type="button"
              data-testid="lang-it-button"
              onClick={() => setLang('it')}
              className={lang === 'it' ? 'text-ink' : 'text-neutral-400'}
            >
              IT
            </button>
            <span className="text-neutral-300">/</span>
            <button
              type="button"
              data-testid="lang-en-button"
              onClick={() => setLang('en')}
              className={lang === 'en' ? 'text-ink' : 'text-neutral-400'}
            >
              EN
            </button>
          </div>
          <button
            type="button"
            data-testid="header-bag-button"
            onClick={() => setOpen(true)}
            className="link-underline uppercase"
          >
            {t('nav.bag')} (<span data-testid="cart-count">{count}</span>)
          </button>
        </div>
      </div>
    </header>
  );
}
